import { action, thunk } from 'easy-peasy';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	loadingDetail: false,
	setLoadingDetail: action((state, payload) => {
		state.loadingDetail = payload;
	}),
	expanded: -1,
	setExpanded: action((state, payload) => {
		state.expanded = payload;
	}),
	items: [],
	save: action((state, payload) => {
		state.items = payload;
	}),
	expanded: -1,
	setExpanded: action((state, payload) => {
		state.expanded = payload;
	}),
	kitDetail: [],
	kitDetailItems: [],
	setKitDetail: action((state, payload) => {
		state.kitDetail = payload;
		state.kitDetailItems = state.kitDetail.kitItems.map(item => ({
			...item.catalog,
			quantity: item.quantity,
			depotDesc: item.depotDescription
		}));
	}),
	detailEan: null,
	setDetailEan: action((state, payload) => {
		state.detailEan = payload;
	}),
	orderBy: 'publicationDate',
	orderDirection: 'desc',
	setOrder: action((state, payload) => {
		if (state.orderBy === payload) {
			state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
		} else {
			state.orderDirection = 'asc';
		}
		state.orderBy = payload;
	}),
	load: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		services.kitUsers
			.retrieve()
			.then(data => {
				actions.save(data.items);
			})
			.catch(e => {
				getStoreActions().error('kit.search');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	getDetail: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingDetail(true);
		return services.kit
			.getDetails(payload)
			.then(data => {
				actions.setKitDetail(data.item);
				return Promise.resolve(data);
			})
			.catch(e => {
				getStoreActions().error('kit.errorGetDetails');
			})
			.finally(_ => {
				actions.setLoadingDetail(false);
			});
	}),
	book: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingDetail(true);
		return services.kitUsers
			.book(payload)
			.then(data => {
				getStoreActions().success('kit.book');
				actions.load();
				return Promise.resolve(data);
			})
			.catch(e => {
				getStoreActions().error('kit.book');
			})
			.finally(_ => {
				actions.setLoadingDetail(false);
			});
	}),
	updateBook: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingDetail(true);
		return services.kitUsers
			.updateBook(payload)
			.then(data => {
				getStoreActions().success('kit.update');
				window.location.reload();
			})
			.catch(e => {
				getStoreActions().error('kit.errorUpdate');
			})
			.finally(_ => {
				actions.setLoadingDetail(false);
			});
	})
};
